

































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'
import RequestButton from '@/components/RequestButton'
import WizardNavigation from './WizardNavigation'

settings =
  name: 'AudienceListingCreateWizard'

  resources:
    form_audience_set:
      resourceName: 'form_audience_set'
      slug: 'suppliers/:supplierId/form_audience_sets/new'

  vue:
    mixins: [WizardService.wizard()]

    components: {
      RequestButton,
      WizardNavigation,
    }

    data: ->
      mode: 'CREATE'
      searchTime: null

    computed:
      audienceSetData: -> @prime?.form_audience_set?.data

      member: -> @$store.member
      supplierId: -> @member.supplier.id

      progressBarStyle: -> { width: (((@activeStep.idx + 1) / @steps.length) * 100)  + '%' }
      isFirstStep: -> @activeStep.idx is 0
      isLastStep: -> @activeStep.idx + 1 is @steps.length
      nextStep: -> @steps[@activeStep.idx + 1]

      wizardRoutes: -> WizardRoutes
      enabledRoutes: -> [@wizardRoutes[0]]

    methods:
      hiClose: ->
        @$router.push({ name: 'AudienceSetListPage' })

      hiPreview: ->

      hiSubmit: ->
        @save()

      save: ->
        clearTimeout(@time)
        @time = setTimeout(() =>
          @saveItem('prime.form_audience_set')
        , 300)

      onSave: (item) ->
        @$router.push({
          name: 'AudienceSetEditPage',
          params: { formAudienceSetId: item.data.id },
          query: { step: @wizardRoutes[1].steps[0].name },
        })

    watch:
      steps: ->
        @navToStepName @$route.query.step, { skipSave: true } if @$route.query.step?

export default VueOptions.vue settings
